import { TDropdown } from "../../shared/modal";

export enum ReqPriority {
    LOW = 1,
    MEDIUM = 2,
    HIGH = 3,
}
export enum ReqTerm {
    CONTRACT = 1,
    CONTRACTTOHIRE = 2,
    PERMANENT = 3,
}
export enum JobType {
    ONSITE = 1,
    REMOTE = 2,
    HYBRID = 3,
}
export enum ReqType {
    NORMAL = 1,
    TOUGH = 2,
}


export const ReqPriorityLabel: Record<ReqPriority, string> = {
    [ReqPriority.LOW]: "Low",
    [ReqPriority.MEDIUM]: "Medium",
    [ReqPriority.HIGH]: "High",
};
export const ReqTermLabel: Record<ReqTerm, string> = {
    [ReqTerm.CONTRACT]: "Contract",
    [ReqTerm.CONTRACTTOHIRE]: "Contract to Hire",
    [ReqTerm.PERMANENT]: "Permanent",
};
export const JobTypeLabel: Record<JobType, string> = {
    [JobType.ONSITE]: "Onsite",
    [JobType.HYBRID]: "Hybrid",
    [JobType.REMOTE]: "Remote",
};
export const ReqTypeLabel: Record<ReqType, string> = {
    [ReqType.NORMAL]: "Normal",
    [ReqType.TOUGH]: "Tough",
};

export const ReqPriorityOptions = Object.values(ReqPriority)
    .filter(v => typeof v === "number")
    .map(v => ({
        id: v,
        name: ReqPriorityLabel[v as ReqPriority]
    }));
export const ReqTermOptions = Object.values(ReqTerm)
    .filter(v => typeof v === "number")
    .map(v => ({
        id: v,
        name: ReqTermLabel[v as ReqTerm]
    }));
export const JobTypeOptions = Object.values(JobType)
    .filter(v => typeof v === "number")
    .map(v => ({
        id: v,
        name: JobTypeLabel[v as JobType]
    }));
export const ReqTypeOptions = Object.values(ReqType)
    .filter(v => typeof v === "number")
    .map(v => ({
        id: v,
        name: ReqTypeLabel[v as ReqType]
    }));

export type TRequirementRecord = {
    id?: number;
    reqType: ReqType;
    clientCompany: TDropdown;
    contactPersonId: number;
    jobTitle: string;
    duration?: number;
    rate?: number;
    jobType: JobType;
    countryId?: number;
    state?: TDropdown;
    stateId?: number;
    city?: TDropdown;
    cityId?: number;
    endClient?: string;
    term: ReqTerm;
    noOfPositions?: number;
    industryId: number
    skillCategoryId: number;
    priority: ReqPriority;
    interviewProcessId: number;
    requiredSkill: string;
    jobDescription: string;
    isTravelRequired: boolean;
    visa: number[];
    sVisa?: TDropdown[];
}

export const EmptyRequirement: TRequirementRecord = {
    reqType: ReqType.NORMAL,
    clientCompany: { id: 0, name: '' },
    contactPersonId: 0,
    industryId: 0,
    interviewProcessId: 0,
    isTravelRequired: false,
    noOfPositions: 1,
    jobDescription: "",
    jobTitle: "",
    jobType: JobType.ONSITE,
    priority: ReqPriority.MEDIUM,
    requiredSkill: "",
    skillCategoryId: 0,
    term: ReqTerm.CONTRACT,
    visa: []
}

export type TRequirement = {
    id?: number;
    reqType: ReqType;
    vendorCompanyId: number;
    vendorCompanyName: string;
    contactPersonId: number;
    contactPersonName: string;
    jobTitle: string;
    duration: number;
    rate: number;
    jobType: JobType;
    cityId?: number;
    cityName?: string;
    stateId?: number;
    stateName?: string;
    countryId?: number;
    countryName?: string;
    endClient: string;
    term: ReqTerm;
    noOfPositions: number;
    industryId: number;
    industryName: string;
    skillCategoryId: number;
    skillCategory: string;
    priority: ReqPriority;
    interviewProcessId: number;
    interviewProcess: string;
    requiredSkill: string;
    jobDescription: string;
    isTravelRequired: boolean;
    postedBy: string;
    postedOn: string;
    isHold: boolean;
    visa?: TDropdown[];
    allocations?: TDropdown[];
    submissions?: { id: number, candidateId: number, candidateName: string, recruiterId: number }[];
}

export type TReqFilter = {
    fromDate: Date | string | null;
    toDate: Date | string | null;
    id: number | null;
    reqType: ReqType | null;
    term: ReqTerm | null;
    priority: ReqPriority | null;
    jobType: JobType | null;
    industryId: number | null;
    skillCategoryId: number | null;
    interviewProcessId: number | null;
    noOfPositions: number | null;
}

export const EmptyReqFilter: TReqFilter = {
    fromDate: new Date(),
    toDate: new Date(),
    id: null,
    reqType: null,
    term: null,
    priority: null,
    jobType: null,
    industryId: null,
    skillCategoryId: null,
    interviewProcessId: null,
    noOfPositions: null,
}
